(function () {
  'use strict';

  // ---- Theme Toggle (Light/Dark) ----
  var savedTheme = localStorage.getItem('csi-theme') || 'dark';
  document.body.setAttribute('data-theme', savedTheme);

  document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var current = document.body.getAttribute('data-theme');
      var next = current === 'dark' ? 'light' : 'dark';
      document.body.setAttribute('data-theme', next);
      localStorage.setItem('csi-theme', next);
    });
  });

  // ---- Sticky Header Scroll ----
  var header = document.querySelector('.site-header');
  var lastScrollY = 0;

  if (header) {
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY;
      if (scrollY > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastScrollY = scrollY;
    }, { passive: true });
  }

  // ---- Mobile Navigation ----
  var mobileNav = document.getElementById('mobile-nav');
  var mobileNavDrawer = mobileNav ? mobileNav.querySelector('.mobile-nav__drawer') : null;
  var mobileNavTrigger = null;

  function openMobileNav(event) {
    if (!mobileNav) return;
    mobileNavTrigger = event && event.currentTarget ? event.currentTarget : document.activeElement;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
    document.body.style.overflow = 'hidden';
    if (mobileNavDrawer) mobileNavDrawer.focus();
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    var wasOpen = mobileNav.classList.contains('is-open');
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    document.body.style.overflow = '';
    if (wasOpen && mobileNavTrigger && typeof mobileNavTrigger.focus === 'function') {
      mobileNavTrigger.focus();
    }
  }

  document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', openMobileNav);
  });

  document.querySelectorAll('[data-mobile-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', closeMobileNav);
  });

  if (mobileNav) {
    var overlay = mobileNav.querySelector('.mobile-nav__overlay');
    if (overlay) overlay.addEventListener('click', closeMobileNav);

    mobileNav.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(
        mobileNav.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return element.getClientRects().length > 0;
      });
      if (!focusable.length) {
        event.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === mobileNavDrawer)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1536 && mobileNav.classList.contains('is-open')) {
        closeMobileNav();
      }
    });
  }

  // ---- Header Search ----
  var searchOverlay = document.getElementById('header-search');
  var searchTrigger = null;

  function openSearch(event) {
    if (!searchOverlay) return;
    searchTrigger = event && event.currentTarget ? event.currentTarget : document.activeElement;
    searchOverlay.removeAttribute('inert');
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
    document.body.style.overflow = 'hidden';
    loadSearchTopSellers();
    var input = searchOverlay.querySelector('.header-search__input');
    if (input) {
      window.requestAnimationFrame(function () {
        input.focus({ preventScroll: true });
      });
      setTimeout(function () {
        input.focus({ preventScroll: true });
      }, 80);
    }
  }

  function closeSearch() {
    if (!searchOverlay) return;
    var wasOpen = searchOverlay.classList.contains('is-open');
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    searchOverlay.setAttribute('inert', '');
    document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    document.body.style.overflow = '';
    if (wasOpen && (searchHideOos || searchOnSale)) {
      var hadActiveSearchFilter = Boolean(
        (searchHideOos && searchHideOos.checked) ||
        (searchOnSale && searchOnSale.checked)
      );
      if (searchHideOos) searchHideOos.checked = false;
      if (searchOnSale) searchOnSale.checked = false;
      if (hadActiveSearchFilter && (!searchHideOos || !searchHideOos.disabled)) renderCurrentSearchProducts();
    }
    if (wasOpen && searchTrigger && typeof searchTrigger.focus === 'function') {
      searchTrigger.focus();
    }
  }

  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', openSearch);
  });

  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', closeSearch);
  });

  if (searchOverlay) {
    searchOverlay.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(
        searchOverlay.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return element.getClientRects().length > 0;
      });
      if (!focusable.length) {
        event.preventDefault();
        searchOverlay.focus();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === searchOverlay)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  // ---- Quick Order Modal ----
  var quickOrderModal = document.getElementById('quick-order-modal');
  var quickOrderDialog = quickOrderModal ? quickOrderModal.querySelector('.quick-order-modal__shell') : null;
  var quickOrderTrigger = null;

  function openQuickOrder(event) {
    if (!quickOrderModal) return;
    var eventTrigger = event && event.currentTarget ? event.currentTarget : document.activeElement;
    quickOrderTrigger = eventTrigger && eventTrigger.hasAttribute && eventTrigger.hasAttribute('data-mobile-menu-close') && mobileNavTrigger
      ? mobileNavTrigger
      : eventTrigger;
    closeSearch();
    closeMobileNav();
    quickOrderModal.removeAttribute('inert');
    quickOrderModal.classList.add('is-open');
    quickOrderModal.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-quick-order-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
    document.body.style.overflow = 'hidden';
    var input = quickOrderModal.querySelector('[data-quick-order-sku]');
    setTimeout(function () {
      if (input) {
        input.focus();
      } else if (quickOrderDialog) {
        quickOrderDialog.focus();
      }
    }, 100);
  }

  function closeQuickOrder() {
    if (!quickOrderModal) return;
    var wasOpen = quickOrderModal.classList.contains('is-open');
    quickOrderModal.classList.remove('is-open');
    quickOrderModal.setAttribute('aria-hidden', 'true');
    quickOrderModal.setAttribute('inert', '');
    document.querySelectorAll('[data-quick-order-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    document.body.style.overflow = '';
    if (wasOpen && quickOrderTrigger && typeof quickOrderTrigger.focus === 'function') {
      quickOrderTrigger.focus();
    }
  }

  document.querySelectorAll('[data-quick-order-toggle]').forEach(function (btn) {
    btn.addEventListener('click', openQuickOrder);
  });

  document.querySelectorAll('[data-quick-order-close]').forEach(function (btn) {
    btn.addEventListener('click', closeQuickOrder);
  });

  if (quickOrderModal) {
    var quickOrderBackdrop = quickOrderModal.querySelector('[data-quick-order-backdrop]');
    if (quickOrderBackdrop) {
      quickOrderBackdrop.addEventListener('dblclick', closeQuickOrder);
    }

    quickOrderModal.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(
        quickOrderModal.querySelectorAll('button:not([disabled]), input:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return element.getClientRects().length > 0;
      });
      if (!focusable.length) {
        event.preventDefault();
        if (quickOrderDialog) quickOrderDialog.focus();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === quickOrderDialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  // ---- Cart Drawer ----
  var cartDrawer = document.getElementById('cart-drawer');
  var cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  var cartDrawerSkippedLines = [];

  function openCartDrawer(skippedLines) {
    if (!cartDrawer) return;
    cartDrawerSkippedLines = Array.isArray(skippedLines) ? skippedLines : [];
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.remove('is-open');
    cartDrawerSkippedLines = [];
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCartDrawer);
  });

  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var itemsEl = document.getElementById('cart-drawer-items');
        var footerEl = document.getElementById('cart-drawer-footer');
        var countEl = document.getElementById('cart-drawer-count');
        var subtotalEl = document.getElementById('cart-drawer-subtotal');

        if (!itemsEl) return;

        if (cart.item_count === 0) {
          var continueShoppingUrl = (window.routes && window.routes.all_products_collection_url) || '/collections/all';
          itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="' + continueShoppingUrl + '" class="btn btn--secondary btn--small">Continue Shopping</a></div>';
          if (footerEl) footerEl.style.display = 'none';
          if (countEl) countEl.textContent = '';
          return;
        }

        if (countEl) countEl.textContent = '(' + cart.item_count + ')';
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        if (footerEl) footerEl.style.display = '';

        var itemsMarkup = cart.items.map(function (item) {
          var itemUrl = item.url || (item.handle ? '/products/' + item.handle : '#');
          var imgSrc = item.featured_image && item.featured_image.url
            ? item.featured_image.url.replace(/(\.\w+)$/, '_160x160$1')
            : '';
          var imgTag = imgSrc
            ? '<img src="' + imgSrc + '" alt="' + escapeHtml(item.title) + '">'
            : '';

          return '<div class="cart-drawer__item">' +
            '<a class="cart-drawer__item-link" href="' + escapeHtml(itemUrl) + '">' +
              '<div class="cart-drawer__item-image">' + imgTag + '</div>' +
              '<div class="cart-drawer__item-info">' +
                '<div class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</div>' +
                (item.variant_title ? '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>' : '') +
                (item.sku ? '<div class="cart-drawer__item-sku">SKU: ' + escapeHtml(item.sku) + '</div>' : '') +
                '<span class="cart-drawer__item-price">' + item.quantity + ' &times; ' + formatMoney(item.price) + '</span>' +
              '</div>' +
            '</a>' +
            '<button class="cart-drawer__item-remove" data-cart-remove="' + item.key + '">Remove</button>' +
          '</div>';
        }).join('');

        var skippedMarkup = cartDrawerSkippedLines.length
          ? '<section class="cart-drawer__skipped" aria-labelledby="cart-drawer-skipped-title">' +
              '<h3 id="cart-drawer-skipped-title">Couldn’t add to cart</h3>' +
              '<ul>' + cartDrawerSkippedLines.map(function (line) {
                return '<li><strong>' + escapeHtml(line.sku) + '</strong>' +
                  (line.title ? '<span>' + escapeHtml(line.title) + '</span>' : '') +
                  '<small>' + escapeHtml(line.reason) + '</small>' +
                  (line.outOfStock && line.variantId
                    ? '<button type="button" class="cart-drawer__stock-alert" data-back-in-stock-trigger data-back-in-stock-label="Get back in stock alert" data-variant-id="' +
                      escapeHtml(line.variantId) + '" data-product-handle="' + escapeHtml(line.productHandle || '') +
                      '">Get back in stock alert</button>'
                    : '') +
                  '</li>';
              }).join('') + '</ul>' +
            '</section>'
          : '';
        itemsEl.innerHTML = itemsMarkup + skippedMarkup;

        itemsEl.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var key = this.getAttribute('data-cart-remove');
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            })
              .then(function () { refreshCartDrawer(); updateCartCount(); })
              .catch(function () {});
          });
        });
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function getPredictiveSearchUrl() {
    var url = window.routes && window.routes.predictive_search_url
      ? window.routes.predictive_search_url
      : '/search/suggest.json';
    var parts = url.split('?');
    var path = parts[0].replace(/\/$/, '');
    if (!/\.json$/i.test(path)) path += '.json';
    return path + (parts[1] ? '?' + parts[1] : '');
  }

  function buildPredictiveSearchUrl(query, limit, fields) {
    var url = new URL(getPredictiveSearchUrl(), window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', String(limit || 10));
    url.searchParams.set('resources[options][fields]', fields);
    url.searchParams.set('resources[options][unavailable_products]', 'last');
    return url.toString();
  }

  // ---- Keyboard: Escape closes overlays ----
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeQuickOrder();
      closeMobileNav();
      closeCartDrawer();
    }
  });

  // ---- Predictive Search ----
  var searchInput = searchOverlay ? searchOverlay.querySelector('input[type="search"]') : null;
  var searchResults = document.getElementById('search-results');
  var searchDebounce = null;
  var searchRequestToken = 0;
  var searchViewAll = searchOverlay ? searchOverlay.querySelector('[data-search-view-all]') : null;
  var searchResultsTitle = searchOverlay ? searchOverlay.querySelector('[data-search-results-title]') : null;
  var searchTopSellers = searchOverlay ? searchOverlay.querySelector('[data-search-top-sellers]') : null;
  var searchHideOos = searchOverlay ? searchOverlay.querySelector('[data-search-hide-oos]') : null;
  var searchOnSale = searchOverlay ? searchOverlay.querySelector('[data-search-on-sale]') : null;
  var searchFilterSummary = searchOverlay ? searchOverlay.querySelector('[data-search-filter-summary]') : null;
  var searchHiddenCount = searchOverlay ? searchOverlay.querySelector('[data-search-hidden-count]') : null;
  var searchClearFilters = searchOverlay ? searchOverlay.querySelector('[data-search-clear-filters]') : null;
  var currentSearchProducts = [];
  var topSellersRequest = null;

  function loadSearchTopSellers() {
    if (!searchTopSellers || searchTopSellers.dataset.loaded === 'true' || topSellersRequest) return;
    var allProductsUrl = window.routes && window.routes.all_products_collection_url
      ? window.routes.all_products_collection_url
      : '/collections/all';
    var url = new URL(allProductsUrl.replace(/\/$/, '') + '/products.json', window.location.origin);
    url.searchParams.set('limit', '4');
    url.searchParams.set('sort_by', 'best-selling');

    topSellersRequest = fetch(url.toString(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Top sellers request failed');
        return response.json();
      })
      .then(function (data) {
        var products = data.products || [];
        if (!products.length) {
          searchTopSellers.innerHTML = '<span class="header-search__loading">No products available.</span>';
          return;
        }
        searchTopSellers.innerHTML = products.map(function (product) {
          var image = product.images && product.images[0]
            ? '<img src="' + escapeHtml(product.images[0].src) + (product.images[0].src.indexOf('?') === -1 ? '?' : '&') + 'width=96" alt="" loading="lazy">'
            : '<span class="header-search__top-seller-placeholder" aria-hidden="true"></span>';
          return '<a class="header-search__top-seller" href="/products/' + encodeURIComponent(product.handle) + '">' +
            image +
            '<span><strong>' + escapeHtml(product.title) + '</strong>' +
            (product.vendor ? '<small>' + escapeHtml(product.vendor) + '</small>' : '') +
            '</span></a>';
        }).join('');
        searchTopSellers.dataset.loaded = 'true';
      })
      .catch(function () {
        searchTopSellers.innerHTML = '<a class="header-search__fallback-link" href="' +
          escapeHtml(allProductsUrl) + '?sort_by=best-selling">Browse top sellers</a>';
      })
      .then(function () {
        topSellersRequest = null;
      });
  }

  function getSearchProductImage(product) {
    var imageUrl = '';
    if (product && product.featured_image && typeof product.featured_image.url === 'string') {
      imageUrl = product.featured_image.url;
    } else if (product && product.images && product.images[0] && typeof product.images[0].src === 'string') {
      imageUrl = product.images[0].src;
    }
    if (!imageUrl) return '<span class="header-search__result-image header-search__result-image--placeholder" aria-hidden="true"></span>';
    return '<img src="' + escapeHtml(imageUrl) + (imageUrl.indexOf('?') === -1 ? '?' : '&') +
      'width=96" alt="" class="header-search__result-image" loading="lazy">';
  }

  function isSearchProductAvailable(product) {
    if (!product) return true;
    if (typeof product.available === 'boolean') return product.available;
    if (typeof product.available_for_sale === 'boolean') return product.available_for_sale;
    if (product.variants && product.variants.length) {
      return product.variants.some(function (variant) {
        return variant && variant.available === true;
      });
    }
    return true;
  }

  function isSearchProductOnSaleOrUnknown(product) {
    if (!product) return true;
    var hasKnownSaleData = false;
    var isOnSale = false;

    var hasProductComparePrice =
      product.compare_at_price !== undefined ||
      product.compare_at_price_min !== undefined ||
      product.compare_at_price_max !== undefined;
    var hasProductPrice = product.price !== undefined || product.price_min !== undefined;
    if (hasProductComparePrice && hasProductPrice) {
      hasKnownSaleData = true;
      var productPrice = Number(product.price_min !== undefined ? product.price_min : product.price);
      var productComparePrice = Number(
        product.compare_at_price_max !== undefined
          ? product.compare_at_price_max
          : (product.compare_at_price_min !== undefined ? product.compare_at_price_min : product.compare_at_price)
      );
      isOnSale = Number.isFinite(productPrice) && Number.isFinite(productComparePrice) && productComparePrice > productPrice;
    }

    if (product.variants && product.variants.length) {
      product.variants.forEach(function (variant) {
        if (
          !variant ||
          !Object.prototype.hasOwnProperty.call(variant, 'compare_at_price') ||
          !Object.prototype.hasOwnProperty.call(variant, 'price')
        ) return;
        hasKnownSaleData = true;
        var variantPrice = Number(variant.price);
        var variantComparePrice = Number(variant.compare_at_price);
        if (Number.isFinite(variantPrice) && Number.isFinite(variantComparePrice) && variantComparePrice > variantPrice) {
          isOnSale = true;
        }
      });
    }

    return isOnSale || !hasKnownSaleData;
  }

  function getSearchProductMarkup(product) {
    var productUrl = product.url || (product.handle ? '/products/' + encodeURIComponent(product.handle) : '#');
    var price = product.price;
    if ((price === undefined || price === null) && product.variants && product.variants[0]) {
      price = product.variants[0].price;
    }
    return '<a href="' + escapeHtml(productUrl) + '" class="header-search__result-item">' +
      getSearchProductImage(product) +
      '<div class="header-search__result-copy">' +
        (product.vendor ? '<div class="header-search__result-vendor">' + escapeHtml(product.vendor) + '</div>' : '') +
        '<div class="header-search__result-title">' + escapeHtml(product.title || '') + '</div>' +
        (price !== undefined && price !== null ? '<div class="header-search__result-price">' + escapeHtml(price) + '</div>' : '') +
      '</div></a>';
  }

  function clearSearchFilterSummary() {
    if (searchFilterSummary) searchFilterSummary.hidden = true;
    if (searchHiddenCount) searchHiddenCount.textContent = '';
  }

  function setSearchFilterLoading(isLoading) {
    if (searchHideOos) searchHideOos.disabled = Boolean(isLoading);
    if (searchOnSale) searchOnSale.disabled = Boolean(isLoading);
  }

  function renderCurrentSearchProducts() {
    var hideOutOfStock = Boolean(searchHideOos && searchHideOos.checked);
    var onSaleOnly = Boolean(searchOnSale && searchOnSale.checked);
    var visibleProducts = currentSearchProducts.filter(function (product) {
      return (!hideOutOfStock || isSearchProductAvailable(product)) &&
        (!onSaleOnly || isSearchProductOnSaleOrUnknown(product));
    });
    var hiddenCount = currentSearchProducts.length - visibleProducts.length;

    if (!currentSearchProducts.length) {
      searchResults.innerHTML = '<div class="header-search__empty">No products found.</div>';
    } else if (!visibleProducts.length && hiddenCount > 0) {
      searchResults.innerHTML = '<div class="header-search__empty header-search__empty--filtered">' +
        'No products match these filters.</div>';
    } else {
      searchResults.innerHTML = visibleProducts.map(getSearchProductMarkup).join('');
    }

    if (hiddenCount > 0 && searchFilterSummary && searchHiddenCount) {
      searchHiddenCount.textContent = hiddenCount + (hiddenCount === 1 ? ' item hidden by filters' : ' items hidden by filters');
      searchFilterSummary.hidden = false;
    } else {
      clearSearchFilterSummary();
    }
  }

  function renderSearchProducts(products) {
    currentSearchProducts = Array.isArray(products) ? products : [];
    renderCurrentSearchProducts();
  }

  function getProvenPredictiveSearchUrl(query) {
    var baseUrl = getPredictiveSearchUrl();
    var separator = baseUrl.indexOf('?') === -1 ? '?' : '&';
    return baseUrl + separator +
      'q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[limit]=12' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku';
  }

  function fetchPredictiveSearchProducts(query) {
    function readProducts(response) {
      if (!response.ok) throw new Error('Search request failed');
      return response.json().then(function (data) {
        return data.resources && data.resources.results && data.resources.results.products
          ? data.resources.results.products
          : [];
      });
    }

    return fetch(getProvenPredictiveSearchUrl(query), { headers: { Accept: 'application/json' } })
      .then(readProducts)
      .catch(function () {
        var shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
        var fallbackUrl = shopifyRoot.replace(/\/?$/, '/') + 'search/suggest.json' +
          '?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=12';
        return fetch(fallbackUrl, { headers: { Accept: 'application/json' } }).then(readProducts);
      });
  }

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchDebounce);
      var query = this.value.trim();
      searchRequestToken += 1;
      var requestToken = searchRequestToken;
      if (searchResultsTitle) searchResultsTitle.textContent = 'Search results';

      if (query.length < 2) {
        currentSearchProducts = [];
        clearSearchFilterSummary();
        setSearchFilterLoading(false);
        searchResults.innerHTML = '<div class="header-search__prompt">Start typing to search products and SKUs.</div>';
        searchResults.removeAttribute('aria-busy');
        if (searchViewAll) searchViewAll.hidden = true;
        return;
      }

      if (searchViewAll) searchViewAll.hidden = true;
      currentSearchProducts = [];
      clearSearchFilterSummary();
      setSearchFilterLoading(true);
      searchResults.innerHTML = '<div class="header-search__loading">Searching Shopify…</div>';
      searchDebounce = setTimeout(function () {
        searchResults.setAttribute('aria-busy', 'true');
        fetchPredictiveSearchProducts(query)
          .then(function (products) {
            if (requestToken !== searchRequestToken) return;
            setSearchFilterLoading(false);
            if (searchViewAll) {
              var searchUrl = new URL((window.routes && window.routes.search_url) || '/search', window.location.origin);
              searchUrl.searchParams.set('q', query);
              searchUrl.searchParams.set('type', 'product');
              searchViewAll.href = searchUrl.pathname + searchUrl.search;
              searchViewAll.hidden = false;
            }
            renderSearchProducts(products);
          })
          .catch(function (error) {
            if (requestToken === searchRequestToken) {
              currentSearchProducts = [];
              clearSearchFilterSummary();
              setSearchFilterLoading(false);
              var fallbackUrl = new URL((window.routes && window.routes.search_url) || '/search', window.location.origin);
              fallbackUrl.searchParams.set('q', query);
              fallbackUrl.searchParams.set('type', 'product');
              searchResults.innerHTML = '<div class="header-search__empty">Search is temporarily unavailable. ' +
                '<a href="' + escapeHtml(fallbackUrl.pathname + fallbackUrl.search) + '">See search results</a></div>';
            }
          })
          .then(function () {
            if (requestToken === searchRequestToken) searchResults.removeAttribute('aria-busy');
          });
      }, 450);
    });

    searchOverlay.querySelectorAll('[data-search-category]').forEach(function (categoryLink) {
      categoryLink.addEventListener('click', function (event) {
        event.preventDefault();
        clearTimeout(searchDebounce);
        searchRequestToken += 1;
        var requestToken = searchRequestToken;
        var categoryTitle = categoryLink.getAttribute('data-search-category-title') || 'Category';
        var collectionUrl = new URL(categoryLink.href, window.location.origin);
        var productsUrl = new URL(collectionUrl.pathname.replace(/\/$/, '') + '/products.json', window.location.origin);
        productsUrl.searchParams.set('limit', '12');

        searchInput.value = '';
        if (searchResultsTitle) searchResultsTitle.textContent = categoryTitle;
        if (searchViewAll) {
          searchViewAll.href = collectionUrl.pathname;
          searchViewAll.hidden = false;
        }
        searchResults.setAttribute('aria-busy', 'true');
        currentSearchProducts = [];
        clearSearchFilterSummary();
        setSearchFilterLoading(true);
        searchResults.innerHTML = '<div class="header-search__loading">Loading ' + escapeHtml(categoryTitle) + '…</div>';

        fetch(productsUrl.pathname + productsUrl.search, { headers: { Accept: 'application/json' } })
          .then(function (response) {
            if (!response.ok) throw new Error('Collection request failed');
            return response.json();
          })
          .then(function (data) {
            if (requestToken !== searchRequestToken) return;
            setSearchFilterLoading(false);
            renderSearchProducts(data.products || []);
          })
          .catch(function () {
            if (requestToken !== searchRequestToken) return;
            currentSearchProducts = [];
            clearSearchFilterSummary();
            setSearchFilterLoading(false);
            searchResults.innerHTML = '<div class="header-search__empty">Couldn’t load this category. ' +
              '<a href="' + escapeHtml(collectionUrl.pathname) + '">View ' + escapeHtml(categoryTitle) + '</a></div>';
          })
          .then(function () {
            if (requestToken === searchRequestToken) searchResults.removeAttribute('aria-busy');
          });
      });
    });

    if (searchHideOos) {
      searchHideOos.addEventListener('change', renderCurrentSearchProducts);
    }
    if (searchOnSale) {
      searchOnSale.addEventListener('change', renderCurrentSearchProducts);
    }

    if (searchClearFilters) {
      searchClearFilters.addEventListener('click', function () {
        if (searchHideOos) searchHideOos.checked = false;
        if (searchOnSale) searchOnSale.checked = false;
        renderCurrentSearchProducts();
        if (searchHideOos) searchHideOos.focus();
      });
    }
  }

  // ---- Quantity Selectors ----
  function sanitizeQuantityValue(input, fallback) {
    if (!input) return fallback || 1;
    var sanitized = String(input.value || '').replace(/[^\d]/g, '');
    var quantity = parseInt(sanitized, 10);
    if (!quantity || quantity < 1) quantity = fallback || 1;
    input.value = String(quantity);
    return quantity;
  }

  function bindQuantitySanitizer(input) {
    if (!input || input.dataset.quantitySanitizerBound === 'true') return;
    input.dataset.quantitySanitizerBound = 'true';
    input.addEventListener('input', function () {
      this.value = String(this.value || '').replace(/[^\d]/g, '');
    });
    input.addEventListener('blur', function () {
      sanitizeQuantityValue(this, 1);
    });
  }

  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.parentElement.querySelector('.product-page__quantity-input');
      var quantity = sanitizeQuantityValue(input, 1);
      if (input && quantity > 1) {
        input.value = String(quantity - 1);
        input.dispatchEvent(new Event('change'));
      }
    });
  });

  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.parentElement.querySelector('.product-page__quantity-input');
      if (input) {
        input.value = String(sanitizeQuantityValue(input, 1) + 1);
        input.dispatchEvent(new Event('change'));
      }
    });
  });

  function submitCartQuantityChange(input) {
    var form = input ? input.closest('form') : null;
    if (!form) return;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    form.submit();
  }

  document.querySelectorAll('[data-cart-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.parentElement.querySelector('.product-page__quantity-input');
      var quantity = sanitizeQuantityValue(input, 1);
      if (input && quantity > 1) {
        input.value = String(quantity - 1);
        submitCartQuantityChange(input);
      }
    });
  });

  document.querySelectorAll('[data-cart-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.parentElement.querySelector('.product-page__quantity-input');
      if (input) {
        input.value = String(sanitizeQuantityValue(input, 1) + 1);
        submitCartQuantityChange(input);
      }
    });
  });

  document.querySelectorAll('.product-page__quantity-input, [data-quick-order-quantity]').forEach(bindQuantitySanitizer);

  // ---- Product Image Gallery ----
  function setProductMainImage(imageUrl, imageAlt, zoomUrl) {
    var mainImage = document.getElementById('product-main-image');
    if (!mainImage || !imageUrl) return;

    var img = mainImage.querySelector('img');
    if (!img) return;

    img.src = imageUrl;
    img.alt = imageAlt || '';
    mainImage.dataset.productImageZoomUrl = zoomUrl || imageUrl;
  }

  function setThumbnailSelection(activeThumb) {
    document.querySelectorAll('.product-page__thumbnail').forEach(function (thumb) {
      var isActive = thumb === activeThumb;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function restoreProductMainImage() {
    var mainImage = document.getElementById('product-main-image');
    if (!mainImage) return;

    var fallbackThumb = document.querySelector('.product-page__thumbnail.is-active');
    if (fallbackThumb) {
      setProductMainImage(fallbackThumb.dataset.imageUrl, fallbackThumb.dataset.imageAlt || '', fallbackThumb.dataset.imageZoomUrl || fallbackThumb.dataset.imageUrl);
      return;
    }

    setProductMainImage(
      mainImage.dataset.productImageUrl,
      mainImage.dataset.productImageAlt || '',
      mainImage.dataset.productImageZoomUrl || mainImage.dataset.productImageUrl
    );
  }

  function findMatchingThumbnail(imageUrl) {
    if (!imageUrl) return null;

    var matchingThumb = null;
    document.querySelectorAll('.product-page__thumbnail').forEach(function (thumb) {
      if (!matchingThumb && thumb.dataset.imageUrl === imageUrl) {
        matchingThumb = thumb;
      }
    });
    return matchingThumb;
  }

  function initProductGallery(root) {
    var scope = root || document;

    scope.querySelectorAll('.product-page__thumbnail').forEach(function (thumb) {
      if (thumb.dataset.galleryInitialized === 'true') return;
      thumb.dataset.galleryInitialized = 'true';

      thumb.addEventListener('click', function () {
        var mainImage = document.getElementById('product-main-image');
        if (!mainImage) return;

        mainImage.dataset.productImageUrl = this.dataset.imageUrl;
        mainImage.dataset.productImageZoomUrl = this.dataset.imageZoomUrl || this.dataset.imageUrl;
        mainImage.dataset.productImageAlt = this.dataset.imageAlt || '';
        setProductMainImage(this.dataset.imageUrl, this.dataset.imageAlt || '', this.dataset.imageZoomUrl || this.dataset.imageUrl);
        setThumbnailSelection(this);
      });
    });
  }

  function getContainedImageRect(container, img) {
    var imgRect = img.getBoundingClientRect();
    var styles = window.getComputedStyle ? window.getComputedStyle(img) : null;
    var paddingLeft = styles ? parseFloat(styles.paddingLeft) || 0 : 0;
    var paddingRight = styles ? parseFloat(styles.paddingRight) || 0 : 0;
    var paddingTop = styles ? parseFloat(styles.paddingTop) || 0 : 0;
    var paddingBottom = styles ? parseFloat(styles.paddingBottom) || 0 : 0;
    var contentWidth = Math.max(imgRect.width - paddingLeft - paddingRight, 1);
    var contentHeight = Math.max(imgRect.height - paddingTop - paddingBottom, 1);
    var naturalWidth = img.naturalWidth || contentWidth;
    var naturalHeight = img.naturalHeight || contentHeight;
    var containerRatio = contentWidth / contentHeight;
    var imageRatio = naturalWidth / naturalHeight;
    var width = contentWidth;
    var height = contentHeight;
    var left = imgRect.left + paddingLeft;
    var top = imgRect.top + paddingTop;

    if (imageRatio > containerRatio) {
      height = width / imageRatio;
      top += (contentHeight - height) / 2;
    } else {
      width = height * imageRatio;
      left += (contentWidth - width) / 2;
    }

    return { left: left, top: top, width: width, height: height };
  }

  function initProductImageZoom(root) {
    var scope = root || document;
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    scope.querySelectorAll('.product-page__main-image').forEach(function (mainImage) {
      if (mainImage.dataset.zoomInitialized === 'true') return;
      mainImage.dataset.zoomInitialized = 'true';

      var img = mainImage.querySelector('img');
      if (!img) return;

      var lens = document.createElement('span');
      lens.className = 'product-page__zoom-lens';
      lens.setAttribute('aria-hidden', 'true');
      mainImage.appendChild(lens);

      function hideLens() {
        mainImage.classList.remove('is-zooming');
      }

      function moveLens(event) {
        if (!img.currentSrc && !img.src) return;

        var containerRect = mainImage.getBoundingClientRect();
        var imageRect = getContainedImageRect(mainImage, img);
        var pointerX = Math.min(Math.max(event.clientX, imageRect.left), imageRect.left + imageRect.width);
        var pointerY = Math.min(Math.max(event.clientY, imageRect.top), imageRect.top + imageRect.height);
        var lensX = pointerX - containerRect.left;
        var lensY = pointerY - containerRect.top;
        var x = pointerX - imageRect.left;
        var y = pointerY - imageRect.top;

        var zoom = 2.35;
        var lensWidth = lens.offsetWidth || 150;
        var lensHeight = lens.offsetHeight || 150;
        var backgroundWidth = imageRect.width * zoom;
        var backgroundHeight = imageRect.height * zoom;
        var backgroundX = Math.min(0, Math.max(lensWidth - backgroundWidth, (lensWidth / 2) - (x * zoom)));
        var backgroundY = Math.min(0, Math.max(lensHeight - backgroundHeight, (lensHeight / 2) - (y * zoom)));
        var backgroundUrl = mainImage.dataset.productImageZoomUrl || img.currentSrc || img.src;

        mainImage.classList.add('is-zooming');
        lens.style.left = lensX + 'px';
        lens.style.top = lensY + 'px';
        lens.style.backgroundImage = 'url("' + backgroundUrl + '")';
        lens.style.backgroundSize = backgroundWidth + 'px ' + backgroundHeight + 'px';
        lens.style.backgroundPosition = backgroundX + 'px ' + backgroundY + 'px';
      }

      mainImage.addEventListener('pointermove', moveLens);
      mainImage.addEventListener('pointerleave', hideLens);
      mainImage.addEventListener('pointercancel', hideLens);
    });
  }

  initProductGallery(document);
  initProductImageZoom(document);

  // ---- Product Variants ----
  function formatProductMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getProductVariantContext(form) {
    var productPage = form ? form.closest('.product-page') : null;
    var productInfo = form ? form.closest('.product-page__info') : null;
    var variantScript = productPage ? productPage.querySelector('[data-product-variants]') : null;
    var variantWeightsScript = productPage ? productPage.querySelector('[data-product-variant-weights]') : null;
    var variantInput = form ? form.querySelector('input[name="id"]') : null;
    var variantButtons = productInfo ? Array.prototype.slice.call(productInfo.querySelectorAll('.product-page__variant-btn')) : [];
    var variants = [];
    var variantWeights = {};

    if (variantScript) {
      try {
        if (variantWeightsScript) {
          variantWeights = JSON.parse(variantWeightsScript.textContent || '{}');
        }

        variants = normalizeProductVariants(JSON.parse(variantScript.textContent || '[]'), variantWeights);
      } catch (error) {
        variants = [];
        variantWeights = {};
      }
    }

    return {
      form: form,
      productPage: productPage,
      productInfo: productInfo,
      variantInput: variantInput,
      variantButtons: variantButtons,
      variants: variants,
      submitBtn: form ? form.querySelector('[data-add-to-cart-label]') : null,
      priceEl: productInfo ? productInfo.querySelector('.product-page__price-current') : null,
      comparePriceContainer: productInfo ? productInfo.querySelector('.product-page__price-compare') : null,
      availabilityEl: productInfo ? productInfo.querySelector('[data-product-availability]') : null,
      availabilityLabelEl: productInfo ? productInfo.querySelector('[data-product-availability-label]') : null,
      shippingNoteEl: productInfo ? productInfo.querySelector('[data-product-shipping-note]') : null,
      skuWraps: productPage ? Array.prototype.slice.call(productPage.querySelectorAll('[data-product-sku-wrap]')) : [],
      skuEls: productPage ? Array.prototype.slice.call(productPage.querySelectorAll('[data-product-sku]')) : [],
      weightWraps: productPage ? Array.prototype.slice.call(productPage.querySelectorAll('[data-product-weight-wrap]')) : [],
      weightEls: productPage ? Array.prototype.slice.call(productPage.querySelectorAll('[data-product-weight]')) : []
    };
  }

  function getSelectedVariantOptions(variantButtons) {
    return variantButtons.reduce(function (selected, button) {
      if (button.classList.contains('is-active')) {
        selected[parseInt(button.dataset.optionIndex, 10)] = button.dataset.value;
      }
      return selected;
    }, []);
  }

  function normalizeProductVariants(variants, variantWeights) {
    if (!Array.isArray(variants)) return [];

    return variants.map(function (variant) {
      var featuredImage = variant.featured_image || variant.image || null;
      var weight = variantWeights && variantWeights[String(variant.id)] ? variantWeights[String(variant.id)] : null;

      return {
        id: variant.id,
        options: variant.options || [variant.option1, variant.option2, variant.option3].filter(function (option) {
          return option !== null && option !== undefined;
        }),
        available: Boolean(variant.available),
        sku: variant.sku || '',
        price: variant.price || 0,
        compare_at_price: variant.compare_at_price || null,
        weight_label: weight && weight.has_weight ? weight.label : '',
        image_url: featuredImage && featuredImage.src ? featuredImage.src : '',
        image_alt: featuredImage && featuredImage.alt ? featuredImage.alt : variant.title || ''
      };
    });
  }

  function findSelectedVariant(context) {
    var selectedOptions = getSelectedVariantOptions(context.variantButtons);

    return context.variants.find(function (variant) {
      return variant.options.every(function (optionValue, index) {
        return selectedOptions[index] === optionValue;
      });
    });
  }

  function variantMatchesOptions(variant, selectedOptions, optionIndex, optionValue) {
    if (!variant || !variant.options) return false;

    return variant.options.every(function (variantOptionValue, index) {
      if (index === optionIndex) return variantOptionValue === optionValue;
      return !selectedOptions[index] || selectedOptions[index] === variantOptionValue;
    });
  }

  function findClosestVariant(context, changedOptionIndex) {
    var selectedOptions = getSelectedVariantOptions(context.variantButtons);
    var selectedValue = selectedOptions[changedOptionIndex];

    return context.variants.find(function (variant) {
      return variantMatchesOptions(variant, selectedOptions, changedOptionIndex, selectedValue);
    });
  }

  function updateVariantButtonVisibility(context) {
    var selectedOptions = getSelectedVariantOptions(context.variantButtons);

    context.variantButtons.forEach(function (button) {
      var optionIndex = parseInt(button.dataset.optionIndex, 10);
      var optionValue = button.dataset.value;
      var hasMatchingVariant = context.variants.some(function (variant) {
        return variantMatchesOptions(variant, selectedOptions, optionIndex, optionValue);
      });

      button.hidden = !hasMatchingVariant;
      button.disabled = !hasMatchingVariant;
      button.setAttribute('aria-hidden', hasMatchingVariant ? 'false' : 'true');
    });
  }

  function setActiveVariantButtons(context, variant) {
    if (!variant || !variant.options) return;

    context.variantButtons.forEach(function (button) {
      var optionIndex = parseInt(button.dataset.optionIndex, 10);
      var isActive = variant.options[optionIndex] === button.dataset.value;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function updateVariantUrl(variant) {
    if (!variant || !window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({ variant: variant.id }, '', url.toString());
  }

  function getAddToCartMarkup(button) {
    var label = button && button.dataset.addToCartLabel ? button.dataset.addToCartLabel : 'Add to Cart';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' + label;
  }

  function getBackInStockMarkup(button) {
    return button && button.dataset.backInStockLabel ? button.dataset.backInStockLabel : 'Get back in stock alert';
  }

  function findExternalBackInStockButton(excludedButton) {
    var productCard = excludedButton ? excludedButton.closest('.product-card') : null;
    var cardButton = productCard ? productCard.querySelector('.rez-out-of-stock-collection-btn') : null;
    if (cardButton && cardButton !== excludedButton) return cardButton;
    if (productCard) return null;

    var rezButton = document.querySelector('.rez-stock-notification-button');
    if (rezButton && rezButton !== excludedButton) return rezButton;

    return Array.prototype.slice.call(document.querySelectorAll('button, a')).find(function (candidate) {
      if (candidate === excludedButton) return false;
      if (candidate.hasAttribute('data-back-in-stock-trigger')) return false;
      if (candidate.closest('[data-product-form]')) return false;
      return /back in stock|notify me|stock alert/i.test(candidate.textContent || '');
    });
  }

  function dispatchBackInStockRequest(button, productPage, productCard) {
    var requestTarget = productPage || productCard || button;
    requestTarget.dispatchEvent(new CustomEvent('back-in-stock:request', {
      bubbles: true,
      detail: {
        variantId: button.dataset.variantId || (productPage ? productPage.dataset.selectedVariantId : '') || '',
        productHandle: button.dataset.productHandle || ''
      }
    }));
  }

  function openRezCollectionBackInStock(button, productPage, productCard) {
    if (productPage) return false;
    var manager = window.REZ_COLLECTION_INSTANCES && window.REZ_COLLECTION_INSTANCES.outOfStockManager;
    var productHandle = button.dataset.productHandle || '';
    if (!manager || !productHandle || typeof manager.handleOutOfStockClick !== 'function') return false;

    var appEvent = {
      target: button,
      preventDefault: function () {},
      stopPropagation: function () {}
    };

    function openFromProductData() {
      var productData = manager.productDataCache && manager.productDataCache.get(productHandle);
      if (!productData) return false;
      Promise.resolve(manager.handleOutOfStockClick(appEvent, productHandle, productData))
        .catch(function () {
          dispatchBackInStockRequest(button, productPage, productCard);
        });
      return true;
    }

    if (openFromProductData()) return true;
    if (typeof manager.fetchProductsByHandles !== 'function') return false;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    Promise.resolve(manager.fetchProductsByHandles([productHandle]))
      .then(function () {
        if (!openFromProductData()) dispatchBackInStockRequest(button, productPage, productCard);
      })
      .catch(function () {
        dispatchBackInStockRequest(button, productPage, productCard);
      })
      .then(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
    return true;
  }

  function hideExternalBackInStockButton(button) {
    if (!button) return;

    button.hidden = true;
    button.setAttribute('aria-hidden', 'true');
    button.dataset.externalBackInStockButton = 'true';

    var wrapper = button.closest('.rez-button-wrapper');
    while (wrapper && wrapper.classList && wrapper.classList.contains('rez-button-wrapper')) {
      wrapper.hidden = true;
      wrapper.setAttribute('aria-hidden', 'true');
      wrapper.style.setProperty('display', 'none', 'important');
      wrapper = wrapper.parentElement;
    }
  }

  function syncExternalBackInStockButton(context, variant) {
    if (!context || !context.productInfo || !variant) return;

    var externalAlertButton = findExternalBackInStockButton(context.submitBtn);
    if (!externalAlertButton) return;

    hideExternalBackInStockButton(externalAlertButton);
  }

  function setProductPurchaseButton(button, variant) {
    if (!button || !variant) return;

    button.disabled = false;
    button.classList.toggle('is-back-in-stock', !variant.available);
    button.toggleAttribute('data-back-in-stock-trigger', !variant.available);
    button.setAttribute('type', variant.available ? 'submit' : 'button');
    button.innerHTML = variant.available ? getAddToCartMarkup(button) : getBackInStockMarkup(button);
  }

  function updateProductVariant(form, options) {
    var context = getProductVariantContext(form);
    if (!context.variantInput || !context.variantButtons.length || !context.variants.length) return;

    var submitBtn = context.submitBtn;
    var mainImage = document.getElementById('product-main-image');
    var comparePriceEl = context.comparePriceContainer ? context.comparePriceContainer.querySelector('s') : null;
    var variant = findSelectedVariant(context);

    if (!variant) {
      variant = findClosestVariant(context, options && typeof options.changedOptionIndex === 'number' ? options.changedOptionIndex : 0);

      if (variant) {
        setActiveVariantButtons(context, variant);
      }
    }

    updateVariantButtonVisibility(context);

    if (!variant) {
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Unavailable';
      }
      return;
    }

    context.variantInput.value = variant.id;
    if (context.productPage) {
      context.productPage.dataset.selectedVariantId = String(variant.id);
    }

    if (!options || options.updateUrl !== false) {
      updateVariantUrl(variant);
    }

    updateProductVariantMeta(context, variant);

    if (context.priceEl) {
      context.priceEl.textContent = formatProductMoney(variant.price);
      context.priceEl.setAttribute('content', (variant.price / 100).toFixed(2));
    }

    if (context.comparePriceContainer && comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatProductMoney(variant.compare_at_price);
        context.comparePriceContainer.hidden = false;
      } else {
        context.comparePriceContainer.hidden = true;
      }
    }

    setProductPurchaseButton(submitBtn, variant);
    syncExternalBackInStockButton(context, variant);

    if (context.availabilityEl) {
      context.availabilityEl.classList.toggle('is-unavailable', !variant.available);
    }

    if (context.availabilityLabelEl) {
      context.availabilityLabelEl.textContent = variant.available ? 'In stock' : 'Out of stock';
    }

    if (context.shippingNoteEl) {
      context.shippingNoteEl.hidden = !variant.available;
    }

    if (mainImage && variant.image_url) {
      mainImage.dataset.productImageUrl = variant.image_url;
      mainImage.dataset.productImageZoomUrl = variant.image_url;
      mainImage.dataset.productImageAlt = variant.image_alt || '';
      setProductMainImage(variant.image_url, variant.image_alt || '', variant.image_url);
      setThumbnailSelection(findMatchingThumbnail(variant.image_url));
    }

    form.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: { variant: variant }
    }));
  }

  function updateProductVariantMeta(context, variant) {
    if (!context || !variant) return;

    context.skuEls.forEach(function (skuEl) {
      skuEl.textContent = variant.sku || '';
    });

    context.skuWraps.forEach(function (skuWrap) {
      skuWrap.hidden = !variant.sku;
    });

    context.weightEls.forEach(function (weightEl) {
      weightEl.textContent = variant.weight_label || '';
    });

    context.weightWraps.forEach(function (weightWrap) {
      weightWrap.hidden = !variant.weight_label;
    });
  }

  function initProductVariants(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-product-form]').forEach(function (form) {
      var context = getProductVariantContext(form);
      if (!context.variantInput || !context.variantButtons.length || !context.variants.length) return;

      var initialVariant = context.variants.find(function (variant) {
        return String(variant.id) === String(context.variantInput.value);
      });

      if (initialVariant) setActiveVariantButtons(context, initialVariant);
      updateProductVariant(form, { updateUrl: false });
    });
  }

  function syncProductBackInStockButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-product-form]').forEach(function (form) {
      var context = getProductVariantContext(form);
      var variant = context.variants.find(function (candidate) {
        return String(candidate.id) === String(context.variantInput ? context.variantInput.value : '');
      });

      syncExternalBackInStockButton(context, variant);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.product-page__variant-btn');
    if (!button) return;

    var form = button.closest('[data-product-form]');
    var productInfo = button.closest('.product-page__info');
    if (!form || !productInfo) return;

    event.preventDefault();

    var optionIndex = button.dataset.optionIndex;
    productInfo.querySelectorAll('.product-page__variant-btn[data-option-index="' + optionIndex + '"]').forEach(function (candidate) {
      candidate.classList.remove('is-active');
      candidate.setAttribute('aria-pressed', 'false');
    });

    button.classList.add('is-active');
    button.setAttribute('aria-pressed', 'true');
    updateProductVariant(form, { updateUrl: true, changedOptionIndex: parseInt(optionIndex, 10) });
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-back-in-stock-trigger]');
    if (!button) return;

    event.preventDefault();

    var productPage = button.closest('.product-page');
    var productCard = button.closest('.product-card');
    var externalAlertButton = findExternalBackInStockButton(button);

    if (externalAlertButton) {
      externalAlertButton.click();
      return;
    }

    if (openRezCollectionBackInStock(button, productPage, productCard)) return;
    dispatchBackInStockRequest(button, productPage, productCard);
  });

  initProductVariants(document);
  syncProductBackInStockButtons(document);
  setTimeout(function () { syncProductBackInStockButtons(document); }, 400);
  setTimeout(function () { syncProductBackInStockButtons(document); }, 1200);

  document.addEventListener('shopify:section:load', function (event) {
    initProductGallery(event.target);
    initProductImageZoom(event.target);
    initProductVariants(event.target);
    syncProductBackInStockButtons(event.target);
  });

  // ---- Product Add-ons ----
  document.querySelectorAll('.product-addon').forEach(function (addon) {
    addon.addEventListener('click', function () {
      var isSelected = this.classList.toggle('is-selected');
      this.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

      if (isSelected && this.dataset.imageUrl) {
        setThumbnailSelection(null);
        setProductMainImage(this.dataset.imageUrl, this.dataset.imageAlt || '', this.dataset.imageUrl);
        return;
      }

      if (!isSelected) {
        var selectedAddons = Array.prototype.slice.call(document.querySelectorAll('.product-addons .product-addon.is-selected'));
        var lastAddonWithImage = selectedAddons.reverse().find(function (selectedAddon) {
          return !!selectedAddon.dataset.imageUrl;
        });

        if (lastAddonWithImage) {
          setThumbnailSelection(null);
          setProductMainImage(lastAddonWithImage.dataset.imageUrl, lastAddonWithImage.dataset.imageAlt || '', lastAddonWithImage.dataset.imageUrl);
          return;
        }

        restoreProductMainImage();
      }
    });
  });

  // ---- AJAX Add to Cart ----
	  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
	    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(this);
      var submitBtn = this.querySelector('[type="submit"]');
      var originalHTML = submitBtn ? submitBtn.innerHTML : '';

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding...'; }

      var items = [{ id: formData.get('id'), quantity: formData.get('quantity') || 1 }];

      var addons = document.querySelectorAll('.product-addons .product-addon.is-selected');
      addons.forEach(function (addon) {
        var addonId = addon.dataset.variantId;
        if (addonId) items.push({ id: parseInt(addonId, 10), quantity: 1 });
      });

      fetch(window.routes ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) { return response.json(); })
        .then(function () {
          updateCartCount();
          openCartDrawer();
          if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = originalHTML; }
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
          if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = originalHTML; }
        });
	    });
	  });

	  // ---- Quick Order by SKU ----
	  document.querySelectorAll('[data-quick-order-form]').forEach(function (form) {
	    var rowsEl = form.querySelector('[data-quick-order-rows]');
	    var addRowBtn = form.querySelector('[data-quick-order-add-row]');
	    var submitBtn = form.querySelector('[type="submit"]');
	    var messageEl = form.querySelector('[data-quick-order-message]');
	    var draftStorageKey = 'csiQuickOrderDraft';
	    var rowId = getQuickOrderRows().length;
	    var isSubmitting = false;
	    var quickOrderProductCache = {};

	    function setQuickOrderMessage(message, state) {
	      if (!messageEl) return;
	      messageEl.textContent = message || '';
	      messageEl.classList.toggle('is-error', state === 'error');
	      messageEl.classList.toggle('is-success', state === 'success');
	    }

	    function setRowStatus(row, message, state) {
	      var status = row.querySelector('[data-quick-order-status]');
	      var skuInput = row.querySelector('[data-quick-order-sku]');
	      if (!status) return;
	      status.textContent = message || '';
	      status.classList.toggle('is-error', state === 'error');
	      status.classList.toggle('is-success', state === 'success');
	      status.classList.toggle('is-loading', state === 'loading');
	      row.classList.toggle('has-error', state === 'error');
	      row.classList.toggle('has-success', state === 'success');
	      if (skuInput) {
	        skuInput.setAttribute('aria-invalid', state === 'error' ? 'true' : 'false');
	        skuInput.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
	      }
	    }

	    function setQuickOrderBackInStockStatus(row, variant) {
	      row._quickOrderFailure = {
	        title: variant.title + (variant.variantTitle && variant.variantTitle !== 'Default Title' ? ' · ' + variant.variantTitle : ''),
	        reason: 'Out of stock',
	        variantId: variant.id,
	        productHandle: variant.productHandle || '',
	        outOfStock: true
	      };
	      setRowStatus(row, variant.title + ' is out of stock.', 'error');
	      var status = row.querySelector('[data-quick-order-status]');
	      if (!status) return;
	      var alertButton = document.createElement('button');
	      alertButton.type = 'button';
	      alertButton.className = 'quick-order__stock-alert is-back-in-stock';
	      alertButton.textContent = 'Get back in stock alert';
	      alertButton.setAttribute('data-back-in-stock-trigger', '');
	      alertButton.setAttribute('data-back-in-stock-label', 'Get back in stock alert');
	      alertButton.setAttribute('data-variant-id', variant.id);
	      status.appendChild(document.createTextNode(' '));
	      status.appendChild(alertButton);
	    }

	    function createQuickOrderRow() {
	      rowId += 1;
	      var statusId = 'quick-order-status-' + rowId;
	      var skuInputId = 'quick-order-sku-' + rowId;
	      var suggestionsId = 'quick-order-suggestions-' + rowId;
	      var row = document.createElement('div');
	      row.className = 'quick-order__row';
	      row.setAttribute('data-quick-order-row', '');
	      row.innerHTML =
	        '<div class="quick-order__field">' +
	          '<label for="' + skuInputId + '"><span>SKU</span></label>' +
	          '<input id="' + skuInputId + '" type="text" name="sku[]" autocomplete="off" placeholder="Enter SKU" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="' + suggestionsId + '" aria-describedby="' + statusId + '" data-quick-order-sku>' +
	          '<div class="quick-order__suggestions" id="' + suggestionsId + '" role="listbox" aria-label="SKU suggestions" data-quick-order-suggestions hidden></div>' +
	        '</div>' +
	        '<label class="quick-order__field quick-order__field--qty">' +
	          '<span>Qty</span>' +
	          '<input type="text" name="quantity[]" value="1" inputmode="numeric" pattern="[0-9]*" aria-label="Quantity" data-quick-order-quantity>' +
	        '</label>' +
	        '<button type="button" class="quick-order__remove-row" data-quick-order-remove-row aria-label="Remove SKU line">' +
	          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16"/><path d="M9 7V4h6v3"/><path d="M7 7l1 13h8l1-13"/><path d="M10 11v5M14 11v5"/></svg>' +
	        '</button>' +
	        '<div class="quick-order__status" id="' + statusId + '" data-quick-order-status aria-live="polite"></div>';
	      return row;
	    }

	    function getQuickOrderRows() {
	      return Array.prototype.slice.call(form.querySelectorAll('[data-quick-order-row]'));
	    }

	    function getQuickOrderDraft() {
	      return getQuickOrderRows().map(function (row) {
	        var skuInput = row.querySelector('[data-quick-order-sku]');
	        var qtyInput = row.querySelector('[data-quick-order-quantity]');
	        return {
	          sku: skuInput ? skuInput.value : '',
	          quantity: qtyInput ? qtyInput.value : '1'
	        };
	      });
	    }

	    function saveQuickOrderDraft() {
	      try {
	        sessionStorage.setItem(draftStorageKey, JSON.stringify(getQuickOrderDraft()));
	      } catch (error) {}
	    }

	    function clearQuickOrderDraft() {
	      try {
	        sessionStorage.removeItem(draftStorageKey);
	      } catch (error) {}
	    }

	    function restoreQuickOrderDraft() {
	      if (!rowsEl) return;

	      try {
	        var draft = JSON.parse(sessionStorage.getItem(draftStorageKey) || '[]');
	        if (!Array.isArray(draft) || !draft.length) return;
	        draft = draft.filter(function (line) {
	          return line && String(line.sku || '').trim();
	        });
	        if (!draft.length) return;

	        while (getQuickOrderRows().length < draft.length) {
	          var addedRow = createQuickOrderRow();
	          rowsEl.appendChild(addedRow);
	          bindQuantitySanitizer(addedRow.querySelector('[data-quick-order-quantity]'));
	        }

	        getQuickOrderRows().forEach(function (row, index) {
	          var line = draft[index] || {};
	          var skuInput = row.querySelector('[data-quick-order-sku]');
	          var qtyInput = row.querySelector('[data-quick-order-quantity]');
	          if (skuInput) skuInput.value = line.sku || '';
	          if (qtyInput) qtyInput.value = line.quantity || '1';
	          setRowStatus(row, '', null);
	        });
	      } catch (error) {}
	    }

	    function productJsonUrl(productUrl) {
	      if (!productUrl) return null;
	      var path = productUrl;
	      try {
	        path = new URL(productUrl, window.location.origin).pathname;
	      } catch (error) {
	        path = productUrl.split('?')[0];
	      }
	      path = path.split('?')[0].replace(/\/$/, '');
	      return path + '.js';
	    }

	    function fetchQuickOrderProduct(productUrl) {
	      var jsonUrl = productJsonUrl(productUrl);
	      if (!jsonUrl) return Promise.resolve(null);
	      if (!quickOrderProductCache[jsonUrl]) {
	        quickOrderProductCache[jsonUrl] = fetch(jsonUrl)
	          .then(function (response) {
	            if (!response.ok) throw new Error('Product request failed');
	            return response.json();
	          })
	          .catch(function (error) {
	            delete quickOrderProductCache[jsonUrl];
	            throw error;
	          });
	      }
	      return quickOrderProductCache[jsonUrl];
	    }

	    function findVariantBySku(sku) {
	      var trimmedSku = String(sku || '').trim();
	      var skuCandidates = [trimmedSku];
	      if (trimmedSku && trimmedSku.charAt(0) !== '#') {
	        skuCandidates.push('#' + trimmedSku);
	      }
	      var normalizedSkus = skuCandidates.map(function (candidate) {
	        return candidate.toLowerCase();
	      });
	      return skuCandidates.reduce(function (searchChain, skuCandidate) {
	        return searchChain.then(function (foundVariant) {
	          if (foundVariant) return foundVariant;

	          return fetch(buildPredictiveSearchUrl(
	            skuCandidate,
	            10,
	            'variants.sku,title,product_type,variants.title,vendor'
	          ), { headers: { Accept: 'application/json' } })
	            .then(function (response) { return response.json(); })
	            .then(function (data) {
	              var products = data.resources && data.resources.results && data.resources.results.products
	                ? data.resources.results.products
	                : [];
	              if (!products.length) return null;

	              return products.reduce(function (chain, product) {
	                return chain.then(function (found) {
	                  if (found) return found;
	                  return fetchQuickOrderProduct(product.url)
	                    .then(function (productData) {
	                      if (!productData) return null;
	                      var variants = productData.variants || [];
	                      var variant = variants.find(function (candidate) {
	                        return normalizedSkus.indexOf(String(candidate.sku || '').trim().toLowerCase()) !== -1;
	                      });
	                      if (!variant) return null;
	                      return {
	                        id: variant.id,
	                        sku: variant.sku,
	                        title: productData.title,
	                        variantTitle: variant.title,
	                        productHandle: productData.handle || '',
	                        available: variant.available
	                      };
	                    })
	                    .catch(function () { return null; });
	                });
	              }, Promise.resolve(null));
	            });
	        });
	      }, Promise.resolve(null));
	    }

	    function findQuickOrderSuggestions(query) {
	      var normalizedQuery = String(query || '').trim().replace(/^#/, '').toLowerCase();
	      if (normalizedQuery.length < 2) return Promise.resolve([]);
	      var queryLooksLikeSku = /[0-9#-]/.test(String(query || ''));
	      var queryCandidates = [query];
	      if (String(query).trim().charAt(0) !== '#') queryCandidates.push('#' + String(query).trim());

	      return Promise.all(queryCandidates.map(function (candidate) {
	        return fetch(buildPredictiveSearchUrl(
	          candidate,
	          8,
	          'variants.sku,title,variants.title,vendor'
	        ), { headers: { Accept: 'application/json' } })
	          .then(function (response) {
	            if (!response.ok) throw new Error('Suggestion request failed');
	            return response.json();
	          })
	          .then(function (data) {
	            return data.resources && data.resources.results && data.resources.results.products
	              ? data.resources.results.products
	              : [];
	          })
	          .catch(function () { return []; });
	      }))
	        .then(function (productGroups) {
	          var seenUrls = {};
	          var products = [];
	          productGroups.forEach(function (group) {
	            group.forEach(function (product) {
	              if (!product.url || seenUrls[product.url]) return;
	              seenUrls[product.url] = true;
	              products.push(product);
	            });
	          });
	          return Promise.all(products.slice(0, 6).map(function (product) {
	            return fetchQuickOrderProduct(product.url).catch(function () { return null; });
	          }));
	        })
	        .then(function (products) {
	          var seenSkus = {};
	          var suggestions = [];
	          products.forEach(function (product) {
	            if (!product) return;
	            (product.variants || []).forEach(function (variant) {
	              var sku = String(variant.sku || '').trim();
	              if (!sku || seenSkus[sku.toLowerCase()]) return;
	              var normalizedSku = sku.replace(/^#/, '').toLowerCase();
	              var normalizedTitle = String(product.title || '').toLowerCase();
	              if (normalizedSku.indexOf(normalizedQuery) === -1 && normalizedTitle.indexOf(normalizedQuery) === -1) return;
	              seenSkus[sku.toLowerCase()] = true;
	              var skuScore = normalizedSku === normalizedQuery
	                ? 0
	                : (normalizedSku.indexOf(normalizedQuery) === 0 ? 1 : (normalizedSku.indexOf(normalizedQuery) !== -1 ? 2 : 4));
	              var titleScore = normalizedTitle === normalizedQuery
	                ? 0
	                : (normalizedTitle.indexOf(normalizedQuery) === 0 ? 1 : (normalizedTitle.indexOf(normalizedQuery) !== -1 ? 2 : 4));
	              suggestions.push({
	                id: variant.id,
	                sku: sku,
	                title: product.title,
	                variantTitle: variant.title,
	                available: variant.available,
	                score: queryLooksLikeSku ? skuScore : titleScore,
	                secondaryScore: queryLooksLikeSku ? titleScore : skuScore
	              });
	            });
	          });
	          return suggestions.sort(function (a, b) {
	            return a.score - b.score || a.secondaryScore - b.secondaryScore || a.sku.localeCompare(b.sku);
	          }).slice(0, 6);
	        });
	    }

	    function closeQuickOrderSuggestions(row) {
	      if (!row) return;
	      clearTimeout(row._quickOrderSuggestionDebounce);
	      row._quickOrderSuggestionToken = (row._quickOrderSuggestionToken || 0) + 1;
	      row._quickOrderSuggestions = [];
	      row._quickOrderSuggestionIndex = -1;
	      var input = row.querySelector('[data-quick-order-sku]');
	      var list = row.querySelector('[data-quick-order-suggestions]');
	      if (input) {
	        input.setAttribute('aria-expanded', 'false');
	        input.removeAttribute('aria-activedescendant');
	      }
	      if (list) {
	        list.hidden = true;
	        list.replaceChildren();
	      }
	      var dialog = row.closest('.quick-order-modal__dialog');
	      if (dialog) {
	        dialog.classList.toggle('has-open-suggestions', Boolean(dialog.querySelector('[data-quick-order-suggestions]:not([hidden])')));
	      }
	    }

	    function setQuickOrderSuggestionIndex(row, index) {
	      var list = row.querySelector('[data-quick-order-suggestions]');
	      var input = row.querySelector('[data-quick-order-sku]');
	      var suggestions = row._quickOrderSuggestions || [];
	      if (!list || !input || !suggestions.length) return;
	      var nextIndex = (index + suggestions.length) % suggestions.length;
	      row._quickOrderSuggestionIndex = nextIndex;
	      list.querySelectorAll('[data-quick-order-suggestion]').forEach(function (option, optionIndex) {
	        var isActive = optionIndex === nextIndex;
	        option.classList.toggle('is-active', isActive);
	        option.setAttribute('aria-selected', isActive ? 'true' : 'false');
	        if (isActive) {
	          input.setAttribute('aria-activedescendant', option.id);
	          if (option.offsetTop < list.scrollTop) {
	            list.scrollTop = option.offsetTop;
	          } else if (option.offsetTop + option.offsetHeight > list.scrollTop + list.clientHeight) {
	            list.scrollTop = option.offsetTop + option.offsetHeight - list.clientHeight;
	          }
	        }
	      });
	    }

	    function renderQuickOrderSuggestions(row, suggestions) {
	      var list = row.querySelector('[data-quick-order-suggestions]');
	      var input = row.querySelector('[data-quick-order-sku]');
	      if (!list || !input) return;
	      list.replaceChildren();
	      row._quickOrderSuggestions = suggestions;
	      row._quickOrderSuggestionIndex = -1;

	      if (!suggestions.length) {
	        list.hidden = true;
	        input.setAttribute('aria-expanded', 'false');
	        input.removeAttribute('aria-activedescendant');
	        return;
	      }

	      suggestions.forEach(function (suggestion, index) {
	        var option = document.createElement('button');
	        option.type = 'button';
	        option.id = list.id + '-option-' + index;
	        option.className = 'quick-order__suggestion';
	        option.setAttribute('role', 'option');
	        option.setAttribute('aria-selected', 'false');
	        option.setAttribute('data-quick-order-suggestion', String(index));

	        var sku = document.createElement('span');
	        sku.className = 'quick-order__suggestion-sku';
	        sku.textContent = suggestion.sku;
	        var title = document.createElement('span');
	        title.className = 'quick-order__suggestion-title';
	        title.textContent = suggestion.title + (suggestion.variantTitle && suggestion.variantTitle !== 'Default Title' ? ' · ' + suggestion.variantTitle : '');
	        option.appendChild(sku);
	        option.appendChild(title);
	        if (!suggestion.available) {
	          var availability = document.createElement('span');
	          availability.className = 'quick-order__suggestion-stock';
	          availability.textContent = 'Out of stock';
	          option.appendChild(availability);
	        }
	        list.appendChild(option);
	      });

	      list.hidden = false;
	      input.setAttribute('aria-expanded', 'true');
	      var dialog = row.closest('.quick-order-modal__dialog');
	      if (dialog) dialog.classList.add('has-open-suggestions');
	    }

	    function scheduleQuickOrderSuggestions(row) {
	      var input = row.querySelector('[data-quick-order-sku]');
	      var query = input ? input.value.trim() : '';
	      closeQuickOrderSuggestions(row);
	      if (query.replace(/^#/, '').length < 2) return;

	      var requestToken = row._quickOrderSuggestionToken;
	      row._quickOrderSuggestionDebounce = setTimeout(function () {
	        findQuickOrderSuggestions(query).then(function (suggestions) {
	          if (
	            row._quickOrderSuggestionToken !== requestToken ||
	            !input ||
	            input.value.trim() !== query
	          ) return;
	          renderQuickOrderSuggestions(row, suggestions);
	        }).catch(function () {
	          if (row._quickOrderSuggestionToken === requestToken) renderQuickOrderSuggestions(row, []);
	        });
	      }, 220);
	    }

	    function selectQuickOrderSuggestion(row, index) {
	      var suggestion = (row._quickOrderSuggestions || [])[index];
	      var input = row.querySelector('[data-quick-order-sku]');
	      if (!suggestion || !input) return;
	      closeQuickOrderSuggestions(row);
	      input.value = suggestion.sku;
	      invalidateQuickOrderRow(row);
	      saveQuickOrderDraft();
	      resolveQuickOrderRow(row, true);
	      input.focus();
	    }

	    function addQuickOrderRow(shouldFocus) {
	      if (!rowsEl) return null;
	      var row = createQuickOrderRow();
	      rowsEl.appendChild(row);
	      bindQuantitySanitizer(row.querySelector('[data-quick-order-quantity]'));
	      saveQuickOrderDraft();
	      var newInput = row.querySelector('[data-quick-order-sku]');
	      if (shouldFocus && newInput) newInput.focus();
	      return row;
	    }

	    function invalidateQuickOrderRow(row) {
	      clearTimeout(row._quickOrderDebounce);
	      row._quickOrderLookupToken = (row._quickOrderLookupToken || 0) + 1;
	      row._quickOrderVariant = null;
	      row._quickOrderResolvedSku = '';
	      row._quickOrderPromise = null;
	      row._quickOrderResolvingSku = '';
	      row._quickOrderFailure = null;
	      setRowStatus(row, '', null);
	    }

	    function resolveQuickOrderRow(row, showEmptyError) {
	      var skuInput = row.querySelector('[data-quick-order-sku]');
	      var sku = skuInput ? skuInput.value.trim() : '';
	      var normalizedSku = sku.toLowerCase();
	      clearTimeout(row._quickOrderDebounce);

	      if (!sku) {
	        invalidateQuickOrderRow(row);
	        if (showEmptyError) setRowStatus(row, 'Enter a SKU', 'error');
	        return Promise.resolve(null);
	      }

	      if (row._quickOrderVariant && row._quickOrderResolvedSku === normalizedSku) {
	        return Promise.resolve(row._quickOrderVariant);
	      }
	      if (row._quickOrderPromise && row._quickOrderResolvingSku === normalizedSku) {
	        return row._quickOrderPromise;
	      }

	      var lookupToken = (row._quickOrderLookupToken || 0) + 1;
	      row._quickOrderLookupToken = lookupToken;
	      row._quickOrderVariant = null;
	      row._quickOrderResolvedSku = '';
	      row._quickOrderResolvingSku = normalizedSku;
	      row._quickOrderFailure = null;
	      setRowStatus(row, 'Checking SKU…', 'loading');

	      row._quickOrderPromise = findVariantBySku(sku).then(function (variant) {
	        if (row._quickOrderLookupToken !== lookupToken || !skuInput || skuInput.value.trim().toLowerCase() !== normalizedSku) {
	          return null;
	        }
	        if (!variant) {
	          row._quickOrderFailure = { title: '', reason: 'SKU not found' };
	          setRowStatus(row, 'SKU not found', 'error');
	          return null;
	        }
	        if (!variant.available) {
	          setQuickOrderBackInStockStatus(row, variant);
	          return null;
	        }
	        row._quickOrderVariant = variant;
	        row._quickOrderResolvedSku = normalizedSku;
	        var variantLabel = variant.variantTitle && variant.variantTitle !== 'Default Title'
	          ? ' · ' + variant.variantTitle
	          : '';
	        setRowStatus(row, variant.title + variantLabel, 'success');
	        return variant;
	      }).catch(function () {
	        if (row._quickOrderLookupToken === lookupToken) {
	          row._quickOrderFailure = { title: '', reason: 'Couldn’t verify SKU' };
	          setRowStatus(row, 'Couldn’t check this SKU. Try again.', 'error');
	        }
	        return null;
	      }).then(function (variant) {
	        if (row._quickOrderLookupToken === lookupToken) {
	          row._quickOrderPromise = null;
	          row._quickOrderResolvingSku = '';
	        }
	        return variant;
	      });
	      return row._quickOrderPromise;
	    }

	    if (addRowBtn && rowsEl) {
	      addRowBtn.addEventListener('click', function () {
	        addQuickOrderRow(true);
	      });
	    }

	    if (rowsEl) {
	      rowsEl.addEventListener('mousedown', function (event) {
	        if (event.target.closest('[data-quick-order-suggestion]')) event.preventDefault();
	      });

	      rowsEl.addEventListener('click', function (event) {
	        var suggestionButton = event.target.closest('[data-quick-order-suggestion]');
	        if (suggestionButton) {
	          var suggestionRow = suggestionButton.closest('[data-quick-order-row]');
	          if (suggestionRow) {
	            selectQuickOrderSuggestion(suggestionRow, parseInt(suggestionButton.getAttribute('data-quick-order-suggestion'), 10));
	          }
	          return;
	        }

	        var removeBtn = event.target.closest('[data-quick-order-remove-row]');
	        if (!removeBtn) return;
	        var row = removeBtn.closest('[data-quick-order-row]');
	        if (!row) return;
	        var rows = getQuickOrderRows();
	        closeQuickOrderSuggestions(row);
	        clearTimeout(row._quickOrderDebounce);
	        row._quickOrderLookupToken = (row._quickOrderLookupToken || 0) + 1;
	        if (rows.length <= 1) {
	          row.querySelectorAll('input').forEach(function (input) { input.value = input.hasAttribute('data-quick-order-quantity') ? '1' : ''; });
	          closeQuickOrderSuggestions(row);
	          invalidateQuickOrderRow(row);
	        } else {
	          var nextFocus = row.nextElementSibling || row.previousElementSibling;
	          row.remove();
	          if (nextFocus) {
	            var nextInput = nextFocus.querySelector('[data-quick-order-sku]');
	            if (nextInput) nextInput.focus();
	          }
	        }
	        saveQuickOrderDraft();
	      });

	      rowsEl.addEventListener('input', function (event) {
	        var row = event.target.closest('[data-quick-order-row]');
	        if (!row) return;
	        saveQuickOrderDraft();
	        if (!event.target.matches('[data-quick-order-sku]')) return;
	        invalidateQuickOrderRow(row);
	        if (!event.target.value.trim()) return;
	        scheduleQuickOrderSuggestions(row);
	        row._quickOrderDebounce = setTimeout(function () {
	          resolveQuickOrderRow(row, false);
	        }, 450);
	      });

	      rowsEl.addEventListener('focusout', function (event) {
	        if (!event.target.matches('[data-quick-order-sku]')) return;
	        var row = event.target.closest('[data-quick-order-row]');
	        if (!row) return;
	        setTimeout(function () { closeQuickOrderSuggestions(row); }, 120);
	        if (event.target.value.trim()) resolveQuickOrderRow(row, false);
	      });

	      rowsEl.addEventListener('keydown', function (event) {
	        if (!event.target.matches('[data-quick-order-sku]')) return;
	        var row = event.target.closest('[data-quick-order-row]');
	        var suggestions = row ? row._quickOrderSuggestions || [] : [];
	        var suggestionsOpen = suggestions.length && event.target.getAttribute('aria-expanded') === 'true';

	        if (suggestionsOpen && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
	          event.preventDefault();
	          var direction = event.key === 'ArrowDown' ? 1 : -1;
	          var currentIndex = typeof row._quickOrderSuggestionIndex === 'number' ? row._quickOrderSuggestionIndex : -1;
	          var nextIndex = currentIndex < 0
	            ? (direction > 0 ? 0 : suggestions.length - 1)
	            : currentIndex + direction;
	          setQuickOrderSuggestionIndex(row, nextIndex);
	          return;
	        }
	        if (suggestionsOpen && event.key === 'Escape') {
	          event.preventDefault();
	          event.stopPropagation();
	          closeQuickOrderSuggestions(row);
	          return;
	        }
	        if (suggestionsOpen && event.key === 'Enter' && row._quickOrderSuggestionIndex >= 0) {
	          event.preventDefault();
	          selectQuickOrderSuggestion(row, row._quickOrderSuggestionIndex);
	          return;
	        }
	        if (event.key !== 'Enter') return;
	        event.preventDefault();
	        if (!row || !event.target.value.trim()) {
	          if (row) setRowStatus(row, 'Enter a SKU', 'error');
	          return;
	        }
	        closeQuickOrderSuggestions(row);
	        resolveQuickOrderRow(row, true);
	        var rows = getQuickOrderRows();
	        if (rows[rows.length - 1] === row) addQuickOrderRow(true);
	      });
	    }

	    restoreQuickOrderDraft();

	    function getFilledQuickOrderLines() {
	      return getQuickOrderRows().map(function (row) {
	        var skuInput = row.querySelector('[data-quick-order-sku]');
	        var qtyInput = row.querySelector('[data-quick-order-quantity]');
	        return {
	          row: row,
	          sku: skuInput ? skuInput.value.trim() : '',
	          quantity: sanitizeQuantityValue(qtyInput, 1)
	        };
	      }).filter(function (line) {
	        return line.sku;
	      });
	    }

	    function clearAddedQuickOrderLines(addedLines) {
	      addedLines.forEach(function (line) {
	        closeQuickOrderSuggestions(line.row);
	        line.row.remove();
	      });

	      if (!getQuickOrderRows().length) {
	        var emptyRow = createQuickOrderRow();
	        rowsEl.appendChild(emptyRow);
	        bindQuantitySanitizer(emptyRow.querySelector('[data-quick-order-quantity]'));
	        clearQuickOrderDraft();
	      } else {
	        saveQuickOrderDraft();
	      }
	    }

	    form.addEventListener('submit', function (event) {
	      event.preventDefault();
	      if (isSubmitting) return;
	      setQuickOrderMessage('', null);
	      var lines = getFilledQuickOrderLines();

	      if (!lines.length) {
	        setQuickOrderMessage('Enter at least one SKU.', 'error');
	        var firstInput = form.querySelector('[data-quick-order-sku]');
	        if (firstInput) firstInput.focus();
	        return;
	      }
	      isSubmitting = true;
	      if (submitBtn) {
	        submitBtn.disabled = true;
	        submitBtn.textContent = 'Checking SKUs…';
	      }

	      Promise.all(lines.map(function (line) {
	        return resolveQuickOrderRow(line.row, true);
	      })).then(function (variants) {
	        var addableLines = [];
	        var skippedLines = [];
	        variants.forEach(function (variant, index) {
	          var line = lines[index];
	          if (variant) {
	            addableLines.push({ row: line.row, variant: variant, quantity: line.quantity });
	            return;
	          }
	          var failure = line.row._quickOrderFailure || {};
	          skippedLines.push({
	            sku: line.sku,
	            title: failure.title || '',
	            reason: failure.reason || 'Couldn’t add this SKU',
	            variantId: failure.variantId || '',
	            productHandle: failure.productHandle || '',
	            outOfStock: failure.outOfStock === true
	          });
	        });

	        if (!addableLines.length) {
	          setQuickOrderMessage('No available products to add. Fix the invalid or out-of-stock lines.', 'error');
	          if (submitBtn) {
	            submitBtn.disabled = false;
	            submitBtn.textContent = 'Add to cart';
	          }
	          isSubmitting = false;
	          return;
	        }

	        var items = addableLines.map(function (line) {
	          return { id: line.variant.id, quantity: line.quantity };
	        });
	        if (submitBtn) submitBtn.textContent = 'Adding…';

	        return fetch(window.routes ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
	          method: 'POST',
	          headers: { 'Content-Type': 'application/json' },
	          body: JSON.stringify({ items: items })
	        })
	          .then(function (response) {
	            if (!response.ok) throw new Error('Unable to add quick order items');
	            return response.json();
	          })
	          .then(function () {
	            updateCartCount();
	            clearAddedQuickOrderLines(addableLines);
	            closeQuickOrder();
	            openCartDrawer(skippedLines);
	          })
	          .catch(function () {
	            setQuickOrderMessage('Unable to add one or more SKUs to cart.', 'error');
	          })
	          .then(function () {
	            if (submitBtn) {
	              submitBtn.disabled = false;
	              submitBtn.textContent = 'Add to cart';
	            }
	            isSubmitting = false;
	          });
	      });
	    });
	  });

	  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.site-header__cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }

  // ---- Collection Sort ----
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // ---- Collection Search ----
  document.querySelectorAll('[data-collection-search-input]').forEach(function (input) {
    var collectionPage = input.closest('.collection-page');
    var grid = collectionPage ? collectionPage.querySelector('[data-collection-grid]') : null;
    var emptyMessage = collectionPage ? collectionPage.querySelector('[data-collection-search-empty]') : null;
    var pagination = collectionPage ? collectionPage.querySelector('.pagination') : null;
    var initialGridHtml = grid ? grid.innerHTML : '';
    var initialCards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-collection-product-card]')) : [];
    var collectionUrl = grid ? grid.getAttribute('data-collection-url') : '';
    var sectionId = grid ? grid.getAttribute('data-collection-section-id') : '';
    var currentPage = parseInt(grid ? grid.getAttribute('data-collection-current-page') : '1', 10) || 1;
    var totalPages = parseInt(grid ? grid.getAttribute('data-collection-total-pages') : '1', 10) || 1;
    var allCardsPromise = null;

    if (!grid || !initialCards.length) return;

    function getCollectionPageUrl(page) {
      var url = new URL(collectionUrl || window.location.pathname, window.location.origin);
      var currentUrl = new URL(window.location.href);
      var sortBy = currentUrl.searchParams.get('sort_by');

      if (sortBy) url.searchParams.set('sort_by', sortBy);
      url.searchParams.set('page', page);
      if (sectionId) url.searchParams.set('section_id', sectionId);

      return url.toString();
    }

    function extractCollectionCards(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var pageGrid = doc.querySelector('[data-collection-grid]');
      return pageGrid ? Array.prototype.slice.call(pageGrid.querySelectorAll('[data-collection-product-card]')) : [];
    }

    function loadCollectionCards() {
      if (allCardsPromise) return allCardsPromise;

      if (totalPages <= 1 || !sectionId) {
        allCardsPromise = Promise.resolve(initialCards.map(function (card) { return card.cloneNode(true); }));
        return allCardsPromise;
      }

      var pageLoads = [];
      for (var page = 1; page <= totalPages; page += 1) {
        if (page === currentPage) {
          pageLoads.push(Promise.resolve(initialCards.map(function (card) { return card.cloneNode(true); })));
        } else {
          pageLoads.push(
            fetch(getCollectionPageUrl(page), { headers: { Accept: 'text/html' } })
              .then(function (response) {
                if (!response.ok) throw new Error('Unable to load collection page');
                return response.text();
              })
              .then(extractCollectionCards)
              .catch(function () { return []; })
          );
        }
      }

      allCardsPromise = Promise.all(pageLoads).then(function (pageCardGroups) {
        return pageCardGroups.reduce(function (allCards, pageCards) {
          return allCards.concat(pageCards);
        }, []);
      });

      return allCardsPromise;
    }

    function renderSearchResults(cards, query) {
      var matchingCards = cards.filter(function (card) {
        var terms = card.dataset.collectionSearch || '';
        return terms.indexOf(query) !== -1;
      });
      var fragment = document.createDocumentFragment();

      matchingCards.forEach(function (card) {
        var cardClone = card.cloneNode(true);
        cardClone.hidden = false;
        fragment.appendChild(cardClone);
      });

      grid.innerHTML = '';
      grid.appendChild(fragment);
      bindGlowCards(grid);

      if (emptyMessage) {
        emptyMessage.hidden = matchingCards.length > 0;
      }
    }

    input.addEventListener('input', function () {
      var query = this.value.trim().toLowerCase();

      if (!query) {
        grid.innerHTML = initialGridHtml;
        bindGlowCards(grid);
        if (emptyMessage) emptyMessage.hidden = true;
        if (pagination) pagination.hidden = false;
        return;
      }

      if (pagination) pagination.hidden = true;
      grid.setAttribute('aria-busy', 'true');

      loadCollectionCards()
        .then(function (cards) {
          if (input.value.trim().toLowerCase() === query) {
            renderSearchResults(cards, query);
          }
        })
        .catch(function () {
          renderSearchResults(initialCards, query);
        })
        .then(function () {
          grid.removeAttribute('aria-busy');
        });
    });
  });

  // ---- Horizontal Carousels ----
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var previous = carousel.parentElement ? carousel.parentElement.querySelector('[data-carousel-prev]') : null;
    var next = carousel.parentElement ? carousel.parentElement.querySelector('[data-carousel-next]') : null;

    if (!track) return;

    function getScrollAmount() {
      return Math.max(track.clientWidth * 0.92, 280);
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 4;
      if (previous) previous.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= maxScroll;
    }

    if (previous) {
      previous.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });

  // ---- Hero Carousel ----
  document.querySelectorAll('[data-hero-carousel]').forEach(function (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
    var previous = hero.querySelector('[data-hero-prev]');
    var next = hero.querySelector('[data-hero-next]');
    var mediaFrames = Array.prototype.slice.call(hero.querySelectorAll('.hero__slide-media-frame'));
    var interactiveTargets = Array.prototype.slice.call(hero.querySelectorAll('a, button'));
    var trackedCtas = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-cta-role]'));
    var pauseTargets = mediaFrames.concat(interactiveTargets);
    var currentIndex = 0;
    var lastPublishedIndex = null;
    var autoRotateTimeout = null;
    var progressFrame = null;
    var autoplayDuration = Math.round((parseInt(hero.getAttribute('data-hero-autoplay-duration'), 10) || 10000) * 0.85);
    var remainingTime = autoplayDuration;
    var startedAt = 0;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!slides.length) return;

    function setProgress(ratio) {
      var boundedRatio = Math.max(0, Math.min(1, ratio));
      dots.forEach(function (dot, dotIndex) {
        dot.style.setProperty('--hero-progress', dotIndex === currentIndex ? String(boundedRatio) : '0');
      });
    }

    function publishHeroEvent(eventName, payload) {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish(eventName, payload);
        return true;
      }
      return false;
    }

    function publishTabView() {
      if (lastPublishedIndex === currentIndex) return;
      var activeSlide = slides[currentIndex];
      if (publishHeroEvent('hero_tab_view', {
        tab_id: activeSlide.getAttribute('data-hero-tab-id'),
        tab_label: activeSlide.getAttribute('data-hero-tab-label'),
        slide_index: currentIndex + 1
      })) {
        lastPublishedIndex = currentIndex;
      }
    }

    function showSlide(index) {
      currentIndex = (index + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      setProgress(0);
      publishTabView();
    }

    function stopAutoRotate() {
      if (autoRotateTimeout) {
        window.clearTimeout(autoRotateTimeout);
        autoRotateTimeout = null;
      }
      if (progressFrame) {
        window.cancelAnimationFrame(progressFrame);
        progressFrame = null;
      }
      if (startedAt) {
        remainingTime = Math.max(0, remainingTime - (Date.now() - startedAt));
        startedAt = 0;
      }
    }

    function animateProgress() {
      if (!startedAt) return;
      var elapsed = Date.now() - startedAt;
      var totalElapsed = autoplayDuration - remainingTime + elapsed;
      setProgress(totalElapsed / autoplayDuration);

      if (elapsed < remainingTime) {
        progressFrame = window.requestAnimationFrame(animateProgress);
      }
    }

    function startAutoRotate(resetTimer) {
      if (slides.length < 2 || reducedMotion) return;
      stopAutoRotate();
      if (resetTimer) {
        remainingTime = autoplayDuration;
        setProgress(0);
      }
      startedAt = Date.now();
      progressFrame = window.requestAnimationFrame(animateProgress);
      autoRotateTimeout = window.setTimeout(function () {
        showSlide(currentIndex + 1);
        startAutoRotate(true);
      }, remainingTime);
    }

    function isWithinPauseTarget(node) {
      if (!node) return false;
      return pauseTargets.some(function (target) {
        return target === node || target.contains(node);
      });
    }

    if (previous) {
      previous.addEventListener('click', function () {
        showSlide(currentIndex - 1);
        startAutoRotate(true);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        showSlide(currentIndex + 1);
        startAutoRotate(true);
      });
    }

    dots.forEach(function (dot, dotIndex) {
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-selected', dotIndex === 0 ? 'true' : 'false');
      dot.addEventListener('click', function () {
        showSlide(dotIndex);
        startAutoRotate(true);
      });
    });

    trackedCtas.forEach(function (cta) {
      cta.addEventListener('click', function () {
        var owningSlide = cta.closest('[data-hero-slide]');
        publishHeroEvent('hero_cta_click', {
          tab_id: owningSlide ? owningSlide.getAttribute('data-hero-tab-id') : null,
          cta_role: cta.getAttribute('data-hero-cta-role'),
          cta_label: cta.textContent.trim(),
          destination: cta.getAttribute('href')
        });
      });
    });

    pauseTargets.forEach(function (target) {
      target.addEventListener('mouseenter', stopAutoRotate);
      target.addEventListener('mouseleave', function (event) {
        if (!isWithinPauseTarget(event.relatedTarget)) {
          startAutoRotate(false);
        }
      });
    });
    hero.addEventListener('focusin', stopAutoRotate);
    hero.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!hero.contains(document.activeElement)) {
          startAutoRotate(false);
        }
      }, 0);
    });

    showSlide(0);
    startAutoRotate(true);
  });

  // ---- Tabbed Sections ----
  function initTabs(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-tab-group]').forEach(function (group) {
      if (group.dataset.tabsInitialized === 'true') return;

      var triggers = group.querySelectorAll('[data-tab-trigger]');
      var panels = group.querySelectorAll('[data-tab-panel]');
      var viewAllLink = group.querySelector('[data-tab-view-all]');

      if (!triggers.length || !panels.length) return;

      group.dataset.tabsInitialized = 'true';

      function activateTab(trigger) {
        var targetId = trigger.getAttribute('data-tab-target');
        triggers.forEach(function (btn) {
          var isActive = btn === trigger;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        if (viewAllLink && trigger.dataset.tabUrl) {
          viewAllLink.setAttribute('href', trigger.dataset.tabUrl);
        }
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          activateTab(trigger);
        });
      });
    });
  }

  initTabs(document);

  document.addEventListener('shopify:section:load', function (event) {
    initTabs(event.target);
  });

  // ---- Cursor Glow Cards ----
  function bindGlowCards(root) {
    var scope = root || document;
    scope.querySelectorAll('.category-card, .new-drop-card, .featured-collection__item, .product-card').forEach(function (card) {
      if (card.dataset.glowBound === 'true') return;
      card.dataset.glowBound = 'true';

    function updateGlow(event) {
      var rect = card.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      card.style.setProperty('--glow-x', x.toFixed(2) + '%');
      card.style.setProperty('--glow-y', y.toFixed(2) + '%');
    }

    card.addEventListener('pointerenter', function (event) {
      card.classList.add('is-glow-active');
      updateGlow(event);
    });

    card.addEventListener('pointermove', updateGlow);

    card.addEventListener('pointerleave', function () {
      card.classList.remove('is-glow-active');
    });
    });
  }

  bindGlowCards(document);

  // ---- Back to Top ----
  var backToTop = document.getElementById('back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 500) {
        backToTop.classList.add('is-visible');
      } else {
        backToTop.classList.remove('is-visible');
      }
    }, { passive: true });

    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ---- Scroll Animations ----
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -60px 0px' }
    );

    document.querySelectorAll('.fade-in').forEach(function (el) { observer.observe(el); });
  }
})();
